import { useCallback, useMemo } from 'react';
import { useI18n } from 'context/i18n';
import { setCookie, COOKIES } from 'utils/helpers';

export const britishCountries = [ 'GB', 'XI' ];

export function useLocale() {
  const { locale, countries } = useI18n();

  const currentCountry = useMemo(() => locale.split('_')[1], [ locale ]);
  const isCountry = useCallback((countryCode) => {
    try {
      if (Array.isArray(countryCode)) {
        if (!countryCode.every((c) => typeof c === 'string')) {
          throw new Error('useLocale: if an array is provided, all elements must be strings');
        }
        return countryCode.some((c) => c === currentCountry);
      }
      if (typeof countryCode !== 'string') {
        throw new Error('useLocale: countryCode must be a string or an array of strings');
      }
      return countryCode === currentCountry;
    } catch (error) {
      console.error(error);
      return false;
    }
  }, [ currentCountry ]);
  // if no code is provided default to currentCountry in url
  const isBritishCountry = useCallback((code = currentCountry) => britishCountries.includes(code ?? ''), [ currentCountry ]);
  const setGBCookie = useCallback((value) => {
    setCookie(COOKIES.GB_COUNTRY, value, 29);
  }, []);

  const getCountries = useCallback((wantedCountries) => countries?.filter((country) => wantedCountries.includes(country.id)) ?? [], [ countries ]);

  return {
    locale, currentCountry, isCountry, isBritishCountry, setGBCookie, getCountries,
  };
}
